import GenericForm from "../../external/ensolvers-core-frontend-mui/components/Common/GenericForm";
import { SpinnerWrapper } from "../SpinnerWrapper";
import { CheckboxComponent, TextFieldComponent } from "../../external/ensolvers-core-frontend-mui/components/Common/FormComponents";
import OpsDialogImage from "../OpsDialogImage";
import Badge from "../../models/Badge";
import { ColorUtils } from "../../utils/ColorUtils";
import { useStyles } from "../Main/formStyles";

interface Props {
  viewBadge: Badge;
  onClose: () => void;
  isLoading: boolean;
}

export default function BadgeViewDialog(props: Props) {
  const customStyles = useStyles();

  return (
    <GenericForm<Badge>
      headerStyles={{ color: ColorUtils.ENSOLVERS_ORANGE_REBRANDING, marginBottom:-10, marginTop:10 }}
      buttonStyles={{ marginRight: 20, color: 'white', backgroundColor: ColorUtils.ENSOLVERS_ORANGE_REBRANDING, marginBottom: 10 }}
      cancelButtonStyles={{ color: ColorUtils.ENSOLVERS_ORANGE_REBRANDING, border: `1px solid ${ColorUtils.ENSOLVERS_ORANGE_REBRANDING}`, marginBottom: 10 }}
      dialogStyles={customStyles.root}
      dialog={true}
      open={!!props.viewBadge}
      instance={props.viewBadge!}
      title={`${props.viewBadge?.name}`}
      onSave={() => props.onClose()}
      dialogCustomSubmitMessage={"Close"}
      hideCancel={true}
      disableBackdropClick
      renderContent={(register, errors, control) => (
        <>
          <SpinnerWrapper isLoading={props.isLoading}>
            <OpsDialogImage viewMode={!!props.viewBadge} selectedFile={props.viewBadge?.iconUrl!} onDelete={() => {}} />

            <TextFieldComponent propertyName={"name"} label="Title" size="small" readOnly={true} defaultValue={props.viewBadge?.name} />

            <TextFieldComponent
              propertyName={"description"}
              label="Description"
              readOnly={true}
              defaultValue={props.viewBadge?.description}
              internalProps={{ multiline: true, rows: 6 }}
              size="small"
            />

            <CheckboxComponent control={control} register={register} errors={errors} propertyName={"level"} label="Level" readOnly={true} />

            <CheckboxComponent
              control={control}
              register={register}
              errors={errors}
              propertyName={"automaticApproval"}
              label="Automatic Approval"
              readOnly={true}
            />
          </SpinnerWrapper>
        </>
      )}
    />
  );
}
